/**
 * Shown on safety controls a User can see but not operate (UNB-1912). Gated
 * controls stay visible and disabled behind this tooltip rather than being
 * hidden, so a permission restriction doesn't read as a missing feature or a
 * bug (UNB-2129). Kept in one place so every gated surface explains it the same.
 */
export const SAFETY_ADMIN_REQUIRED = {
  title: "Admin access required",
  description: "Only Merchant or Workspace Admins can configure safety. Ask a workspace admin for access.",
};

/** Under `SAFETY_ADMIN_REQUIRED` where it links to the team list, sorted to show the admins first. */
export const SAFETY_ADMINS_LINK = "See who can configure";

/** Shown on GMV Max capabilities that can't run without TikTok Ads authorised. */
export const TIKTOK_ADS_AUTH_REQUIRED = {
  title: "Unbox needs permission to change your TikTok ads.",
  description: "Select 'Authorise TikTok ads' on the right of this row to start using this feature.",
};
